import { ESTABLECIMIENTOS_COLUMN_NAMES } from './../../../constants/establecimientos.constants';
import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatListModule } from '@angular/material/list';
import { CrudViewComponent } from '../../../shared/components/crud/view/view';
import { EstablecimientoInterface } from '../../../models/establecimiento.model';
import { EstablecimientosService } from '../../../core/establecimientos.service';
// Debes crear EstablecimientosService
import { BaseCrud, typeAction } from '../../../shared/baseCrud.component';

@Component({
  selector: 'app-establecimientos-view',
  imports: [CommonModule, MatListModule, CrudViewComponent],
  templateUrl: './establecimientos-view.component.html',
  styleUrls: ['./establecimientos-view.component.scss']
})
export class EstablecimientosViewComponent extends BaseCrud<EstablecimientoInterface> {
  type = <typeAction>'view';
  apiService = inject(EstablecimientosService);
  columnNames = ESTABLECIMIENTOS_COLUMN_NAMES;
}
